// extracted by mini-css-extract-plugin
module.exports = {"text":"PageIntroText_text__jcxZa"};